<template>
  <div class="CharactoristicCertificatesorApproval flex-jc-bt">
    <div class="flex-50 left-side">
      <SpCard custom-class="sp-color-bg-4 card-content">
        <div v-for="(cert, index) in shipCharacteristicCert">
          <div v-if="Object.keys(cert.options).length === 1">
            <div v-for="(op, opKey) in cert.options">
              <div class="flex fs-int item">
                <SpRadio v-model="shipInfo.certificates[opKey].certificateId" :value="opKey">{{ op.name }}</SpRadio>
              </div>
              <div class="flex-al-center item">
                <div class="flex-28 label">{{ $l('IssuedBy') }}</div>
                <div class="flex-72">
                  <SpInput v-model="shipInfo.certificates[opKey].issuedBy"
                           :validate-reg="/^((?=.[a-zA-Z])[A-Za-z0-9-.,\/()&’” ]{3,256})?$/"
                           :disabled="!shipInfo.certificates[opKey].certificateId"
                           :type="!shipInfo.certificates[opKey].certificateId ? 'gray':'warn'" />
                </div>
              </div>
              <div class="flex-al-center item">
                <div class="flex-28 label">{{ $l('PeriodofValidity') }}</div>
                <div class="flex-72 flex-al-center">
                  <span class="flex-10 unit">{{ $l('From') }}</span>
                  <SpDatePicker v-model="shipInfo.certificates[opKey].activatedDate"
                                :disabled="!shipInfo.certificates[opKey].certificateId"
                                :type="!shipInfo.certificates[opKey].certificateId ? 'gray':'warn'"
                                class="flex-40" width="1" type="grayBorder1" placeholder=" " />
                  <span class="flex-10 unit">{{ $l('To') }}</span>
                  <SpDatePicker v-model="shipInfo.certificates[opKey].expiredDate"
                                :disabled="!shipInfo.certificates[opKey].certificateId"
                                :type="!shipInfo.certificates[opKey].certificateId ? 'gray':'warn'"
                                class="flex-40" width="1" type="grayBorder1" placeholder=" " />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="flex fs-int item-outer">{{ cert.name }}</div>
            <div v-for="(op, opKey) in cert.options" class="pd-l-20">
              <div class="flex fs-int item">
                <SpRadio v-model="shipInfo.certificates[opKey].certificateId" :value="opKey">{{ op.name }}</SpRadio>
              </div>
              <div class="flex-al-center item">
                <div class="flex-28 label">{{ $l('IssuedBy') }}</div>
                <div class="flex-72">
                  <SpInput v-model="shipInfo.certificates[opKey].issuedBy"
                           :validate-reg="/^((?=.[a-zA-Z])[A-Za-z0-9-.,\/()&’” ]{3,256})?$/"
                           :disabled="!shipInfo.certificates[opKey].certificateId"
                           :type="!shipInfo.certificates[opKey].certificateId ? 'gray':'warn'" />
                </div>
              </div>
              <div class="flex-al-center item">
                <div class="flex-28 label">{{ $l('PeriodofValidity') }}</div>
                <div class="flex-72 flex-al-center">
                  <span class="flex-10 unit">{{ $l('From') }}</span>
                  <SpDatePicker v-model="shipInfo.certificates[opKey].activatedDate"
                                :disabled="!shipInfo.certificates[opKey].certificateId"
                                :type="!shipInfo.certificates[opKey].certificateId ? 'gray':'warn'"
                                class="flex-40" width="1" type="grayBorder1" placeholder=" " />
                  <span class="flex-10 unit">{{ $l('To') }}</span>
                  <SpDatePicker v-model="shipInfo.certificates[opKey].expiredDate"
                                :disabled="!shipInfo.certificates[opKey].certificateId"
                                :type="!shipInfo.certificates[opKey].certificateId ? 'gray':'warn'"
                                class="flex-40" width="1" type="grayBorder1" placeholder=" " />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex fs-int item">
          <SpRadio v-model="shipInfo.otherApproval" :value="1">{{ $l('Others') }}</SpRadio>
        </div>

        <div class="flex-al-center item">
          <SpInput v-model="shipInfo.otherApprovalDesc" :disabled="!shipInfo.otherApproval" :type="!shipInfo.otherApproval? 'gray' : 'warn'" text-type="textarea" row="3" />
        </div>
      </SpCard>
      <p class="reminder">{{ $l('Reminder') }}</p>
    </div>
    <div class="flex-48 mg-t-40 right-side sp-color-bg-4">
      <ShipInfoTable v-model="shipInfo" />
      <div class="fs-int outer-gap sp-color-11 text-left">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</div>
      <div class="fs-int mg-t-20 opacity-50 sp-color-11 text-left">{{ $l('CertificateofMOC') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/cert/moc" accept="image/*" />
      <div class="fs-int mg-t-20 opacity-50 sp-color-11 text-left">{{ $l('CertificateofIMBCCode') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/cert/imsbc" accept="image/*" />
      <div class="fs-int mg-t-20 opacity-50 sp-color-11 text-left">{{ $l('CertificateofRightShip') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/cert/right" accept="image/*" />
      <div class="fs-int mg-t-20 opacity-50 sp-color-11 text-left">{{ $l('CertificateofDangerousGoodsLicense') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/cert/dgl" accept="image/*" />
      <div class="fs-int mg-t-20 opacity-50 sp-color-11 text-left">{{ $l('Others') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/cert/other" accept="MIME_type" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard'
import SpInput from '@/components/common/SpInput'
import SpSelect from '@/components/common/SpSelect'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import ShipInfoTable from '@/components/shipOwner/tonnages/newTonnage/ShipInfoTable'
import SpRadio from '@/components/common/SpRadio.vue'
import { getShipCharacteristicCertApi, getShipStructureTypeApi } from '@/request/APIs/so'
import SpDatePicker from '@/components/common/SpDatePicker'
export default {
  name: 'CharactoristicCertificatesorApproval',

  nameSpace: 'shipOwner.tonnages.newTonnage.CharactoristicCertificatesorApproval',

  components: {
    SpDatePicker,
    SpCard,
    SpInput,
    SpSelect,
    SpUploadGroup,
    ShipInfoTable,
    SpRadio
  },

  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  emits: ['update:modelValue'],

  data () {
    return {
      shipCharacteristicCert: {}
    }
  },

  computed: {
    shipInfo: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    }
  },

  created () {
    this.getShipCharacteristicCert()
  },

  mounted () {
  },

  methods: {
    // 获取按结构划分的船舶类型选项
    getShipCharacteristicCert () {
      getShipCharacteristicCertApi().then(res => {
        this.shipCharacteristicCert = res.data
        this.formatCertificates(res.data)
      })
    },

    formatCertificates (certs) {
      const keys = Object.keys(certs)
      keys.forEach(key => {
        if (certs[key].options) {
          const optionsKeys = Object.keys(certs[key].options)
          optionsKeys.forEach(opKey => {
            this.shipInfo.certificates[opKey] = {
              certificateId: null,
              issuedBy: null,
              activatedDate: null,
              expiredDate: null
            }
          })
        } else {
          this.shipInfo.certificates[certs[key].id] = {
            certificateId: null,
            issuedBy: null,
            activatedDate: null,
            expiredDate: null
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.CharactoristicCertificatesorApproval{
  .card-content{
    padding: @gap;
    .item-outer{
      margin:@gap*2 0 @gap 0;
    }
  }
  .right-side{
    box-sizing:border-box;
    padding:@gap;
  }
  .outer-gap{
    margin-top: @gap*3;
  }
}
</style>
